import { render } from "./A107010.vue?vue&type=template&id=5919921e&scoped=true"
import script from "./A107010.vue?vue&type=script&lang=js"
export * from "./A107010.vue?vue&type=script&lang=js"

import "./A107010.vue?vue&type=style&index=0&id=5919921e&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5919921e"]])

export default __exports__